<div class="area-display"
     data-testid="job-areas-area-display">
  <div class="area-list-container"
       [class.is-editing]="isEditing()"
       data-testid="job-areas-list">
    @for (zone of areasByZone().keys(); track zone.id) {
      <div class="zone-group"
           data-testid="job-areas-zone-card">
        <div class="zone-header">
          <div class="zone-name">
            {{zone.name}}
          </div>
          <i class="pi pi-ellipsis-v actions-button"
             [class.faded]="isEditing()"
             (click)="openActionMenu(zone.id, zone.name)"
             data-testid="job-areas-icon-zone-options"></i>
        </div>
        @for (area of areasByZone().get(zone) ?? []; track area.id) {
          <app-locations-area-card [area]="area"
                                   [isNewlyAdded]="newAreaID() === area.id"
                                   [locationAction]="currentAction()"
                                   (onToggleNaStatus)="onToggleNaStatus($event)">
          </app-locations-area-card>
        }
        <div class="na-area"
             data-testid="job-areas-text-na-rooms">
          {{ naRoomTextByZone()(zone)}}
        </div>
      </div>
    }
  </div>
</div>

@if (currentAction() !== LocationAction.Viewing) {
  <div class="submit-na-drawer"
       data-testid="job-areas-drawer-na-actions">
    <div class="drawer-actions-container">
      @if (hasAreasMarkedForNaChange()) {
        <p-button severity="primary"
                  styleClass="bqa-primary-btn p-fullwidth-button"
                  data-testid="job-areas-btn-na-complete"
                  [loading]="isSavingAreaNaChanges()"
                  (click)="saveAreaNaChanges()">
          Complete
        </p-button>
      } @else {
        <p-button severity="contrast"
                  [outlined]="true"
                  styleClass="bqa-primary-btn p-fullwidth-button"
                  data-testid="job-areas-btn-na-close"
                  (click)="cancelMarkingNa()">
          Close
        </p-button>
      }
      <div class="severity-info-text">
        <img src="assets/icons/info.svg"
             alt="Information"
             class="severity-info-icon">
        <span>Use N/A only if the item is not part of the home's plan (e.g., no
          stairs). Don't use N/A if the item is missing but required.</span>
      </div>
    </div>
  </div>
}

<p-drawer styleClass="options-drawer"
          [style]="{'border-radius': '8px 8px 0 0'}"
          dismissible
          [visible]="isActionMenuVisible()"
          (visibleChange)="isActionMenuVisible.set($event)"
          [closable]="false"
          position="bottom"
          data-testid="job-areas-drawer-zone-options">
  <ng-template #headless>
    <div class="options-drawer">
      @if (selectedZone() !== UNSELECTED_ZONE) {
        <div class="drawer-buttons-container">
          <button class="drawer-button"
                  (click)="openAddAreaDialog()"
                  data-testid="job-areas-btn-add-room">Add a Room</button>
          <button class="drawer-button"
                  (click)="openEditRoomNameDialog()"
                  data-testid="job-areas-btn-edit-room-name">Edit Room Name</button>
          @if (canMarkAreaAsNa()) {
            <button class="drawer-button"
                    (click)="setMarkAsNaMode()"
                    data-testid="job-areas-btn-mark-na">Mark an area as N/A</button>
          }
          @if (canRemoveAreaFromNa()) {
            <button class="drawer-button"
                    (click)="setRemoveNaMode()"
                    data-testid="job-areas-btn-remove-na">Remove N/A</button>
          }
        </div>
      }
    </div>
  </ng-template>
</p-drawer>


<app-edit-room-names [visible]="editingRoomNames()"
                     [zones]="zones()"
                     [areas]="editableAreas()"
                     [isSaving]="isSavingAreaUpdates()"
                     (visibleChange)="onEditRoomNamesVisibleChange($event)"
                     (saveRoomNames)="saveEditedRoomNames($event)">
</app-edit-room-names>


<app-add-area-dialog [visible]="addingArea()"
                     [zoneName]="selectedZoneName()"
                     [areasConfig]="areasConfig()"
                     [isSaving]="isSavingAreaUpdates()"
                     [existingAreas]="areasWithDetails()"
                     (visibleChange)="onAddAreaVisibleChange($event)"
                     (addArea)="onAddArea($event)">
</app-add-area-dialog>